<template>
  <v-layout>
    <v-card-text class>
      <staff-validate
        v-if="bulk.fileName && bulk.category.includes('Staff')"
        :bulk="bulk"
        @process="process"
      ></staff-validate>

      <student-validate
        v-if="bulk.fileName && bulk.category.includes('Students')"
        :bulk="bulk"
        @process="process"
      ></student-validate>

      <v-card v-if="invalidList.length > 0">
        <v-card-title class="title"
          >{{ bulk.fileName && (bulk.fileName.split(".") || [""])[0] }} -
          Invalid
          <v-spacer></v-spacer>
          <v-btn
            class="elevation-0"
            color="clear"
            @click="processFlowIndex = 1"
          >
            <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
        </v-card-title>
        <!-- <v-data-table
          dense
          :headers="invalidHeadersList(bulk.headers)"
          :items="invalidList"
          :item-key="this.activeCategory === 'Staff' ? 'SFKEY' : 'STKEY'"
          class="elevation-0"
          no-action
        >
          <template slot="items" slot-scope="props">
            <td v-for="head in bulk.headers" :key="head">
              <div v-if="props.item[head]">
                {{ props.item[head] }}
              </div>
              <div v-else style="color: red">
                {{ "N/A" }}
              </div>
            </td>
          </template>
        </v-data-table> -->
      </v-card>
      <v-card v-if="validList.length > 0" class="mt-3">
        <v-card-title class="title"
          >{{ bulk.fileName && (bulk.fileName.split(".") || [""])[0] }} - Valid
          <v-spacer></v-spacer>
          <v-btn class="elevation-0" color="clear" @click="updateBulk">
            <!-- <v-icon>update</v-icon> -->
            Update
          </v-btn>
          <v-btn class="elevation-0" color="clear" @click="insertBulk">
            <!-- <v-icon>add</v-icon> -->
            Add New
          </v-btn>
        </v-card-title>

        <staff-upload
          v-if="activeCategory === 'Staff'"
          :headers="validHeaders"
          :list="validList"
        ></staff-upload>

        <student-upload
          v-if="activeCategory != 'Staff'"
          :headers="validHeaders"
          :list="validList"
          :classes="classes"
        ></student-upload>
      </v-card>
    </v-card-text>
  </v-layout>
</template>

<script>
import StaffValidate from "./StaffValidate";
import StudentValidate from "./StudentValidate";
import StaffUpload from "./StaffUpload";
import StudentUpload from "./StudentUpload";
import APIBulk from "@/mixins/APIBulk";
import APIClassType from "@/mixins/APIClassType";
export default {
  props: {
    bulk: Object,
    activeCategory: String
  },
  components: {
    StaffValidate,
    StudentValidate,
    StaffUpload,
    StudentUpload
  },
  mixins: [APIBulk, APIClassType],
  data() {
    return {
      classes: [],
      validList: [],
      invalidList: [],
      activeUser: {},
      validHeaders: [],
      keymap: {},
      classMap: {}
    };
  },
  watch: {
    classes: {
      handler: function() {
        for (let ob of this.classes) {
          this.classMap[ob.class_type] = ob.value;
        }
      },
      deep: true
    }
  },
  methods: {
    process: function(map, required, type, classes) {
      if (!map[Object.keys(map)[0]]) {
        this.$toast.error(
          "Failed to process records, check whether the fields mapping are correct.",
          "Error",
          {
            position: "topCenter"
          }
        );
        return;
      }

      this.keymap = map;
      this.validList = [];
      this.invalidList = [];
      if (!classes && type != "staff") {
        this.listClassTypes();
      } else {
        this.classes = classes;
      }
      this.checkForValidity();
    },
    invalidHeadersList: function(obs) {
      return obs.map(ob => {
        return { text: ob, value: ob, sortable: false };
      });
    },
    checkForValidity: function() {
      if (!this.bulk || !this.bulk.data) {
        this.$toast.error("Failed to procceed with bulk list.", "Error");
        return;
      }

      if (!this.keymap) {
        this.$toast.error(
          "Invaild mapping in excel. check and review the excel sheet.",
          "Error"
        );
        return;
      }

      let keys = Object.keys(this.keymap);
      // let modelKeys = keys.map(ob => {
      //   return this.keymap[ob];
      // });

      // if (!this.keymap["student_id"]) {
      //   this.$toast.error("Student key can not be empty.", "Error");
      //   return;
      // }

      // if (!this.keymap["first_name"]) {
      //   this.$toast.error("First name can not be empty.", "Error");
      //   return;
      // }''

      for (let item of this.bulk.data) {
        let ob = this.processedOb(item);
        if (this.isValidRecord(item)) {
          this.validList.push(ob);
        } else {
          this.invalidList.push(item);
        }
      }
      this.validHeaders = keys.map(ob => {
        return { text: ob.toUpperCase(), value: ob, sortable: false };
      });
    },
    processedOb: function(item) {
      let jsonob = JSON.stringify(Object.assign({}, this.keymap));
      Object.keys(item).forEach(key => {
        let value = item[key];
        jsonob = jsonob.replace(key, value);
      });
      jsonob = this.removeKeysInJson(jsonob);
      return JSON.parse(jsonob);
    },
    removeKeysInJson: function(jsonob) {
      for (const key of Object.keys(this.keymap)) {
        let isReplace = jsonob.includes(this.keymap[key]);
        let isStatus = ["enable_print_label", "status"].includes(key);
        if (isReplace && !isStatus) {
          jsonob = jsonob.replace(this.keymap[key], "N/A");
        }
      }
      return jsonob;
    },
    isValidRecord: function(val) {
      if (this.activeCategory === "Staff" && !val["SFKEY"]) {
        return false;
      } else if (
        this.activeCategory === "Primary Students" ||
        this.activeCategory === "Secondary Students"
      ) {
        if (!val["STKEY"]) {
          return false;
        }
      }
      return true;
    },
    updateRemains: function(val) {
      this.$set(this.remainList, val, true);
    },
    checkInvalidRecords: function() {
      for (let item of this.bulk.data) {
        if (!item.email) {
          this.invalidList.push(item);
        }
      }
    },
    insertBulk: function() {
      if (this.activeCategory == "Staff") {
        this.addStaffBulk(0);
      } else {
        this.addStudentBulk(0);
      }
    },
    updateBulk: function() {
      if (this.activeCategory == "Staff") {
        this.addStaffBulk(1);
      } else {
        this.addStudentBulk(1);
      }
    },
    addStudentBulk: async function(mode) {
      let list = this.validList; // .slice(0, 5);
      let self = this;
      list = list.map(obj => {
        let classtype = obj.class;
        if (!classtype) {
          return null;
        }
        let object = Object.assign({}, obj);
        if (obj.class instanceof Object) {
          object.class = obj.class.value;
        } else {
          object.class = self.classMap[obj.class];
        }
        return object;
      });

      try {
        let result;
        if (mode === 1) {
          result = await this.studentsJsonBulkUpdate(list);
        } else {
          result = await this.studentsJsonBulk(list);
        }
        if (result.error != null) {
          this.$toast.error("Failed to fetch details!", "Error", {
            position: "topCenter"
          });
          return;
        }
        if (result.uploaded_error && result.uploaded_error.length > 0) {
          this.$toast.error(
            "Failed to upload " + result.uploaded_error.length + " records.",
            "Error",
            {
              position: "topCenter"
            }
          );
          return;
        }
        this.$toast.success(
          this.activeCategory + " list added to system.",
          "Success",
          {
            position: "topCenter"
          }
        );
      } catch (error) {
        this.$toast.error("Failed to fetch details!", "Error", {
          position: "topCenter"
        });
      }
    },
    addStaffBulk: async function() {
      if (this.activeCategory != "Staff") {
        return;
      }

      let list = this.validList;
      try {
        let result = {};
        if (this.activeCategory === "Staff") {
          result = await this.staffJsonBulk(list);
        } else {
          result = await this.studentsJsonBulk(list);
        }
        if (result.error != null) {
          this.$toast.error("Failed to fetch details!", "Error", {
            position: "topCenter"
          });
          return;
        }
        this.$toast.success("Staff list added to system.", "Success", {
          position: "topCenter"
        });
      } catch (error) {
        this.$toast.error("Failed to fetch details!", "Error", {
          position: "topCenter"
        });
      }
    },
    listClassTypes: async function() {
      try {
        let list = await this.getClassTypes();
        this.classes = list.map(ob => {
          let obj = ob;
          obj.text = ob.class_type;
          obj.value = ob._id;
          return obj;
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
